import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

interface state {
	choices: [],
	graphSeenOnStatement: boolean[],
	currentStatementId: number,
	resultsSeenSinceLastChange: boolean,
	resultsSeenSinceStart: boolean
}

const state: state = {
	choices: [],
	graphSeenOnStatement: [],
	currentStatementId: 0,
	resultsSeenSinceLastChange: false,
	resultsSeenSinceStart: false
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
